import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { getCompanyPreview } from "@/api/endpoints/companyPreview";

export function useGetCompanyPreview(cui: string | undefined) {
  return useQuery({
    queryKey: queryKeys.companyPreview.byCui(cui || ""),
    queryFn: () => getCompanyPreview({ cui: cui! }),
    enabled: !!cui && cui.length >= 2,
    // Ruta publică consumă cota ANAF: o singură reîncercare, doar la erori de server.
    retry: (numarIncercari, eroare) =>
      numarIncercari < 1 &&
      ((eroare as Error & { status?: number }).status ?? 0) >= 500,
  });
}
